import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';

export function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post('/api/admin/auth/login', { username, password });
      navigate('/');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          background: '#fff',
          padding: 48,
          border: '1px solid #e5e5e5',
          borderRadius: 8,
          width: '100%',
          maxWidth: 400,
        }}
      >
        <h1
          style={{
            margin: '0 0 32px',
            fontFamily: 'Georgia, serif',
            fontSize: 22,
            letterSpacing: 3,
            textTransform: 'uppercase',
            fontWeight: 400,
            textAlign: 'center',
          }}
        >
          This place is your space · Admin
        </h1>

        <label style={{ display: 'block', fontSize: 13, color: '#6b7280', marginBottom: 4 }}>
          Username or email
        </label>
        <input
          value={username}
          autoComplete="username"
          autoCapitalize="none"
          spellCheck={false}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          required
          style={inputStyle}
        />

        <label
          style={{
            display: 'block',
            fontSize: 13,
            color: '#6b7280',
            marginTop: 16,
            marginBottom: 4,
          }}
        >
          Password
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={inputStyle}
        />

        {error && (
          <p style={{ color: '#b91c1c', fontSize: 13, marginTop: 16, marginBottom: 0 }}>{error}</p>
        )}

        <button type="submit" disabled={busy} style={{ ...buttonStyle, marginTop: 24 }}>
          {busy ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #e5e5e5',
  borderRadius: 6,
  fontSize: 14,
  fontFamily: 'inherit',
};

const buttonStyle: React.CSSProperties = {
  width: '100%',
  padding: '12px 16px',
  background: '#1a1a1a',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 500,
  letterSpacing: 1,
  cursor: 'pointer',
};
